import React, { useEffect } from "react";
import styled from "styled-components";
import { useRecoilState, useRecoilValue } from "recoil";
import { loadingState, selectLive, selectSize, selectTab } from "atoms";
import { useInfiniteQuery } from "react-query";
import { ReactComponent as JIcon } from "../assets/Icon/JIcon.svg";
import { ReactComponent as WIcon } from "../assets/Icon/WIcon.svg";

const Table = () => {
  const [, setLoading] = useRecoilState(loadingState);
  const size = useRecoilValue(selectSize);
  const live = useRecoilValue(selectLive);
  const date = useRecoilValue(selectTab);

  const { data, hasNextPage, fetchNextPage, status } = useInfiniteQuery(
    ["table_data", live, size, date],
    async ({ pageParam = 1, year = "all" }) => {
      const data = await fetch(
        `/comExec/realestate/?action=apt_price&type=${
          live === "m" ? "m" : "jw"
        }&areatype=m2&py=${size}&year=${year}&page=${pageParam}&row_count=5`
      ).then((res) => res.json());
      return {
        res: data,
        nextPage: pageParam + 1,
      };
    },
    {
      staleTime: 60 * 5000,
      getNextPageParam: (lastPage) => {
        if (lastPage.res.data.length !== 0) {
          return lastPage.nextPage;
        }
      },
    }
  );

  useEffect(() => {
    status === "loading" ? setLoading(true) : setLoading(false);
  }, [status, setLoading]);

  return (
    <TableComponent className="text-gray-800">
      <TableHeaderComponent className="d-flex flex-row py-2 align-items-center border-0 bg-gray-100 text-center">
        <TableFirstColumn className="font-weight-500">계약일</TableFirstColumn>
        <TableSecondColumn className="font-weight-500">가격</TableSecondColumn>
        <TableThirdColumn className="font-weight-500">타입</TableThirdColumn>
        <TableFourthColumn className="font-weight-500">동 층</TableFourthColumn>
      </TableHeaderComponent>
      {status === "loading" ? null : status === "error" ? (
        <p style={{ textAlign: "center" }}>표시할 데이터가 없습니다</p>
      ) : (
        <>
          {data.pages.map((data) => {
            return data.res.data.map((data) => {
              const {
                uid,
                year,
                month,
                day,
                dong,
                floor,
                type,
                money_ko,
                rent,
              } = data;

              return (
                <TableRowComponent
                  key={uid}
                  className="d-flex flex-row py-2 align-items-center border-bottom border-gray-200"
                >
                  <TableFirstColumn className="text-center">
                    {year.slice(2, 4)}-{month}-{day < 10 ? `0${day}` : day}
                  </TableFirstColumn>
                  <TableSecondColumn className="text-center">
                    {live === "jw" && rent !== "0" && <WIcon />}{" "}
                    {live === "jw" && rent === "0" && <JIcon />} {money_ko}
                    {rent && rent !== "0" && `/${rent}`}
                  </TableSecondColumn>
                  <TableThirdColumn className="text-center">
                    {type}
                  </TableThirdColumn>
                  <TableFourthColumn className="text-center">
                    {dong}동 {floor}층
                  </TableFourthColumn>
                </TableRowComponent>
              );
            });
          })}

          {hasNextPage ? (
            <AppendButton
              className="w-100 my-3 btn btn-outline-gray-300 text-gray-500"
              onClick={fetchNextPage}
            >
              더보기
            </AppendButton>
          ) : (
            <AppendButton className="w-100 my-3 btn btn-outline-gray-300 text-gray-400">
              더이상 거래내역이 존재하지 않습니다.
            </AppendButton>
          )}
        </>
      )}
    </TableComponent>
  );
};

const TableComponent = styled.div``;
const TableRowComponent = styled.div``;
const TableText = styled.span``;

const TableHeaderComponent = styled(TableRowComponent)``;
const TableFirstColumn = styled(TableText)`
  width: 25%;
`;
const TableSecondColumn = styled(TableText)`
  width: 35%;
`;
const TableThirdColumn = styled(TableText)`
  width: 10%;
`;
const TableFourthColumn = styled(TableText)`
  width: 30%;
`;

const AppendButton = styled.button``;

export default Table;
